import classes from "./Introduction.module.css";
import React, { useEffect, useContext, useState } from "react";
import { images } from "../../assets/img";
import BookNowBtn from "../BookNowBtn";
import RemoteConfig from "../../services/RemoteConfig";
import AuthContext from "../../store/auth-context";
import { NAIL_SHOP_INFO } from "../../utils/Const";
import useCheckIsMobile from "../../hook/useCheckIsMobile";

//ABOUT US
const Introduction = (props) => {
  const { introductionRef } = props || {};
  const { isFetchActivateRemoteConfig } = useContext(AuthContext);
  const [image, setImage] = useState(images.popup);
  const isMobile = useCheckIsMobile();

  // useEffect(() => {
  //   const introduction_image = RemoteConfig.getConfigValue("introduction_image");
  //   introduction_image && setImage(introduction_image);
  // }, [isFetchActivateRemoteConfig]);

  return (
    <div ref={introductionRef} className={classes.introduction}>
      <div className={classes.introHeader}>
        <h2 className={classes.cursiveText}>{NAIL_SHOP_INFO.name}</h2>
      </div>
      <div className={classes.rowWrapper}>
        <img alt={"Intro"} src={image} className={classes.introImg} />
        <div className={classes.introTextContainer}>
          <div>
            <h1>
              {"Happy Nails Great Barr - Premier Nail Salon in Great Barr"}
            </h1>
            {/* <h3 className={classes.greyIntroTextContainer}>
              Happy Nails Great Barr - Premier Nail Salon in Great Barr
            </h3> */}
          </div>
          <p className={classes.greyIntroTextContainer}>
            Happy Nails Great Barr is your premier nail salon in Great Barr,
            Birmingham, located at 12 Birmingham Rd, B43 6NR. We specialise in
            professional manicure, pedicure, gel nails, acrylic nails, and
            bespoke nail art. Our skilled nail technicians deliver flawless
            results in a friendly and relaxing atmosphere, making us the top
            choice for nail care in Great Barr. Visit us for beautiful nails
            that last and an experience you’ll love.
          </p>
          <p className={classes.greyIntroTextContainer}>
            Whether you’re looking for a quick polish change, a luxury spa
            pedicure, or eye-catching nail art designs, our Great Barr nail
            salon has something for everyone. Using high-quality products and
            the latest techniques, we ensure your nails not only look stunning
            but also stay healthy. Conveniently located near local shops and
            with free parking available, Happy Nails Great Barr is the perfect
            spot to treat yourself. Book your appointment today and see why
            we’re one of the most recommended nail salons in Birmingham B43
          </p>
          <BookNowBtn />
        </div>
      </div>
    </div>
  );
};

export default Introduction;
